<template>
  <div v-bind="$attrs" :class="propClasses" class="gap-size">
    <slot />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { BaseProps, BASE_PROPS_DEFAULTS } from '@/models/types/BaseProps'
import { useBaseProps } from '@/hooks/useBaseProps'

defineEmits(['update:modelValue'])
defineOptions({
  name: 'lp-grid',
})

const props = withDefaults(defineProps<BaseProps>(), BASE_PROPS_DEFAULTS)
const { propClasses } = useBaseProps(props)

const gapSize = computed(() => `${props.gap}rem`)
</script>
<style>
.gap-size {
  gap: v-bind(gapSize) !important;
}
</style>
